import { PriceDotIndicator } from "@apac/ui";
import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { IPriceRangeTagsProps } from "@tenant/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

export const PriceRangeTags = ({
  priceTags,
  className,
}: IPriceRangeTagsProps) => {
  const { t } = useI18nContext();
  const legend = [
    t("core-flights.search.dateSelection.calendarPriceTags.lowest"),
    t("core-flights.search.dateSelection.calendarPriceTags.low"),
    t("core-flights.search.dateSelection.calendarPriceTags.medium"),
    t("core-flights.search.dateSelection.calendarPriceTags.high"),
  ];

  const [block, cn] = useModuleBEM(
    styles,
    CoreUiComponents.CalendarPriceRangeTags
  );

  return (
    <div className={clsx(block, className)}>
      <div className={cn("container")}>
        <div className={cn("section")}>
          {priceTags?.map((_, index: number) => (
            <div
              key={index}
              className={cn("tag-root", {
                [`bucket-${index}`]: true,
              })}
            >
              <div className={cn("tag-container")}>{legend[index]}</div>
              <PriceDotIndicator
                priceBucket={index}
                className={cn("price-dot-indicator")}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
